import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'

import generalController from '../../../controllers/generalController';
import { languageController } from '../../../controllers/language/languageController';
import { formatPhoneNumber, setItemOnLocalStorage, getBaseUrl } from '../../../utils/helpers';
import { generateGoogleDirection } from '../../../utils/googleMapHelper'
import { localStorageKeys } from '../../../utils/constants';

import Hours from './Hours/Hours';
import Collapse from '../Collapse/Collapse'
import Button from '../../1_Atoms/Button/Button';
import IconText from '../../1_Atoms/IconText/IconText';
import Link from '../../1_Atoms/Link/Link';
import { Svg } from '../../1_Atoms/Svg/Svg';
import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';
import DealerStar from './DealerStar/DealerStar';

function DealerCard({
  dealerData,
  isLean,
  index,
  isActive,
  onClick,
  userCurrentPos,
  onSelect,
  isSelected,
  BaSALink,
  BaTDLink,
  GaQLink,
  language,
  isEmbeddedOnBnP,
  currentLang,
  cardsRef,
  setIsModalOpen,
  setDealerData,
  displayServiceHoursOnly = false,
  isModelPreOrder = false
}) {
  if (!dealerData) return '';

  const { name, address_line_1, city, post_code, website, phone_number, hours, ev_service, geolocation, award_winning } = dealerData;

  const formattedPhoneNumber = phone_number ? formatPhoneNumber(phone_number) : null;
  const isFR = (currentLang && currentLang === 'fr');

  const [isStarred, setIsStarred] = useState(
    () => window.mzFunc?.checkCookie('preferredDealer') === dealerData.dealer_code.toString()
  );

  const getTransformedWebsiteUrl = (website) => {
    let transformedWebsiteUrl = website.toLocaleLowerCase();

    if(transformedWebsiteUrl.indexOf("http://") === 0)
      transformedWebsiteUrl = transformedWebsiteUrl.replace("http://", "https://");

    if(transformedWebsiteUrl.indexOf("http//") === 0)
      transformedWebsiteUrl = transformedWebsiteUrl.replace("http//", "https://");

    if(transformedWebsiteUrl.indexOf("https//") === 0)
      transformedWebsiteUrl = transformedWebsiteUrl.replace("https//", "https://");

    if(transformedWebsiteUrl.indexOf("https://") !== 0)
      transformedWebsiteUrl = "https://" + transformedWebsiteUrl;

    return transformedWebsiteUrl;
  }

	const getVehicle =  (type)=>{
    if(sessionStorage.getItem('SelectedVehicle')){
  		const sessionVehicle = JSON.parse(sessionStorage.getItem('SelectedVehicle'));
	  	return sessionVehicle[type];
    }else{
      return '';
    }
	}

  const cardTop = (
    <div className="mz-dealer-card__top">
      <div className="mz-dealer-card__number">
        <span className="text--white">{!window.bnp_retailer_mode && index}</span>
        <Svg
          size={2.5}
          colour={isActive ? 'red' : 'grey'}
          type="pin"
        />

      </div>
      <div className={`mz-dealer-card__basic-info ${award_winning ? 'award_style' : ''} ${isStarred ? 'starred_style' : ''}`}>
        {isStarred &&
          <div className="mz-bg--red label mz-dealer-card_starred">
            <i className="mz-svg mz-svg--white mz-svg-star_solid"></i>
            <span className="text--white">{languageController.getCopy('findDealer','preferred_retailer')}</span>
          </div>
        }
        <div className="mz-dealer-card__name upper ls-md">
          {name}
         </div>
        <p className="mz-dealer-card__address font-small ls-normal">{address_line_1}, {city}, {post_code}</p>
        <p className="mz-dealer-card__distance font-small text--grey ls-normal">
          {geolocation.distance && geolocation.distance.toFixed(0) > 0 ? geolocation.distance.toFixed(2) + ' km' : ''}
        </p>
      </div>
      {award_winning && 
          <div className="mz-dealer-card__award">
            <img src={`${getBaseUrl()}/globalassets/mazda-canada/react/images/excellenceaward2023_Mini_${generalController.detectLanguage()}.png`} /><Tooltip TooltipText={languageController.getCopy('findDealer','award')} />
          </div>
      }
    </div>
  )

  const anyServices =  dealerData.trade_in_tool_link ===''
      && dealerData.sms_chat_link ===''
      && dealerData.credit_app_link ===''
      && dealerData.online_purchase_link ===''
      && dealerData.live_chat_link ===''
      && dealerData.ev_service ===false ? false : true ;
  const services = anyServices && !displayServiceHoursOnly ? ( <>
    <div className="mz-dealer-card__services">
      <div className="font-small upper medium">{languageController.getCopy('findDealer','availableServices')}</div>
      {
        dealerData.ev_service === true && (
          <IconText
            label={languageController.getCopy('findDealer','serviceEV')}
            iconType="ev_dealer"
            iconSize={1}
            iconColour="red"
            iconTop="1px"
            className="caption"
          />
        )
      }
      {
        dealerData.credit_app_link && (
          <IconText
            label={(
              <Link
                text={languageController.getCopy('findDealer','serviceCreditApplication')}
                href={dealerData.credit_app_link}
                target="_blank"
                data-menu-name="Dealer Credit App"
                data-form-name="Find a dealer"
                data-form-dealer={name}
                data-form-event="Visit website"
              />
            )}
            iconType="credit_application"
            iconSize={1}
            iconColour="grey"
            iconTop="1px"
            className="caption"
          />
        )
      }
      {
        dealerData.live_chat_link && (
          <IconText
            label={(
              <Link
                text={languageController.getCopy('findDealer','serviceLiveChat')}
                href={dealerData.live_chat_link}
                target="_blank"
                data-menu-name="Dealer Live Chat"
                data-form-name="Find a dealer"
                data-form-dealer={name}
                data-form-event="Visit website"
              />
            )}
            iconType="live_chat"
            iconSize={1}
            iconColour="grey"
            iconTop="1px"
            className="caption"
          />
        )
      }
      {
        dealerData.trade_in_tool_link && (
          <IconText
            label={(
              <Link
                text={languageController.getCopy('findDealer','serviceTradeIn')}
                href={dealerData.trade_in_tool_link}
                target="_blank"
                data-menu-name="Dealer Trade In"
                data-form-name="Find a dealer"
                data-form-dealer={name}
                data-form-event="Visit website"
              />
            )}
            iconType="trade_in"
            iconSize={1}
            iconColour="grey"
            iconTop="1px"
            className="caption"
          />
        )
      }
      {
        dealerData.sms_chat_link && (
          <IconText
            label={(
              <Link
                text={languageController.getCopy('findDealer','serviceSMS')}
                href={isNaN(dealerData.sms_chat_link) ? dealerData.sms_chat_link : 'tel:' + dealerData.sms_chat_link}
                target="_blank"
                data-menu-name="Dealer SMS"
                data-form-name="Find a dealer"
                data-form-dealer={name}
                data-form-event="Send SMS"
              />
            )}
            iconType="sms"
            iconSize={1}
            iconColour="grey"
            iconTop="1px"
            className="caption"
          />
        )
      }
      {
        dealerData.online_purchase_link && (
          <IconText
            label={(
              <Link
                text={languageController.getCopy('findDealer','serviceOnlinePurchasing')}
                href={dealerData.online_purchase_link}
                target="_blank"
                data-menu-name="Dealer Online Purchase"
                data-form-name="Find a dealer"
                data-form-dealer={name}
                data-form-event="Visit website"
              />
            )}
            iconType="cart"
            iconSize={1}
            iconColour="grey"
            iconTop="1px"
            className="caption"
          />
        )
      }
    </div>
  </>) : (<></>);

  return (
    <>
      <div className={`mz-dealer-card ${isSelected ? 'selected' : ''}`} ref={el => cardsRef.current[index - 1] = el}>
        <Collapse
          buttonContent={cardTop}
          isActive={isActive}
          onClick={onClick}
          index={index}
        >
        <DealerStar 
          isStarred={isStarred}
          setIsStarred={setIsStarred}
          dealerId={dealerData.dealer_code}
          dealerName={dealerData.name}
          onToggle={(dealerData, isStarred) => {
            console.log(`Dealer ${dealerData.dealer_code} is now ${isStarred ? 'starred' : 'unstarred'}`);
          }}
        />
          <div className="mz-dealer-card__contact" style={window.bnp_retailer_mode ? {'justify-content': 'left'} : {}}>
            {
              website && !window.bnp_retailer_mode &&(
                <IconText
                  label={(
                    <Link
                      text={languageController.getCopy('global', 'dealerWebsite')}
                      href={getTransformedWebsiteUrl(website)}
                      target="_blank"
                      data-menu-name="Dealer Website"
                      data-form-name="Find a dealer"
                      data-form-dealer={name}
                      data-form-event="Visit website"
                    />
                  )}
                  iconType="website"
                  iconSize={1}
                  iconColour="red"
                  iconTop="1px"
                  className="caption"
                />
              )
            }
            
            {
              formattedPhoneNumber && (
                <IconText
                  label={(
                    <Link
                      text={formattedPhoneNumber}
                      href={`tel:${formattedPhoneNumber}`}
                      data-menu-name="Dealer Phone Number"
                      data-form-name="Find a dealer"
                      data-form-dealer={name}
                      data-form-event="Dial dealer phone number"
                    />
                  )}
                  iconType="phone"
                  iconSize={1}
                  iconColour="red"
                  iconTop="1px"
                  className={!window.bnp_retailer_mode ? "caption" : ""}
                />
              )
            }
            {window.bnp_retailer_mode && <div style={{flex:"0 0 30px"}}></div>}
            <IconText
              label={(
                <Link
                  text={languageController.getCopy('global', 'dealerDirections')}
                  href={generateGoogleDirection(userCurrentPos, { lat: geolocation.latitude, lng: geolocation.longitude })}
                  target="_blank"
                  data-menu-name="Dealer Directions"
                  data-form-name="Find a dealer"
                  data-form-dealer={name}
                  data-form-event="Open google map"
                />
              )}
              iconType="address"
              iconSize={1}
              iconColour="red"
              iconTop="1px"
              className={!window.bnp_retailer_mode ? "caption" : ""}
            />
          </div>
          <div>
            {!window.bnp_retailer_mode && services}
          </div>
          <div className="mz-dealer-card__hours">
            {displayServiceHoursOnly ? 
              <Hours
                  isInitOpened={false}
                  days={hours.service}
                  label={languageController.getCopy('findDealer', 'hoursService')}
                  is24HFormat={isFR}
                />
              : 
              <>
              {
                hours.sales && (
                  <Hours
                    days={hours.sales}
                    isInitOpened={true}
                    label={languageController.getCopy('findDealer', 'hoursSales')}
                    isNoDrawer={isLean}
                    is24HFormat={isFR}
                  />
                )
              }
              {
                (hours.parts && !isLean) && (
                  <Hours
                    days={hours.parts}
                    label={languageController.getCopy('findDealer', 'hoursParts')}
                    is24HFormat={isFR}
                  />
                )
              }
              {
                (hours.service && !isLean) && (
                  <Hours
                    days={hours.service}
                    label={languageController.getCopy('findDealer', 'hoursService')}
                    is24HFormat={isFR}
                  />
                )
              }
              </>
            }
          </div>
          <div className="mz-dealer-card__cta">
            {
              isLean ? (
                isEmbeddedOnBnP ? (
                  <Fragment>
                    <Button
                      label={isSelected ? 'Selected' : languageController.getCopy('findDealer', 'bookTestDriveCta')} // todo
                      className={isSelected ? 'mz-btn--primary' : 'mz-btn--primary mz-btn--red'}
                      buttonIconPosition="right"
                      onClick={onSelect}
                      data-menu-name="Book a Test Drive"
                      data-form-name="Find a dealer"
                      data-form-event="Visit Book a Test Drive"
                    />
                    {isModelPreOrder ?
                    <Link
                      text={languageController.getCopy('findDealer', 'preOrder')}
                      className="mz-btn mz-btn--secondary"
                      onClick={(e) => {
                        e.preventDefault();

                        window.postMessage(
                          {
                              type: "formEvent",
                              origin: 'preOrder',
                              message: dealerData,
                          },
                          "*"
                        )
                      }} />
                    :
                    <Link
                      text={languageController.getCopy('findDealer', 'reserveYours')}
                      className="mz-btn mz-btn--secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        if(window.bnp_retailer_mode){
                          window.postMessage(
                                {
                                    type: "formEvent",
                                    origin: 'form',
                                    message: 'open',
                                },
                                "*"
                            )
                        }else{
                          window.postMessage(
                            {
                                type: "formEvent",
                                origin: 'getLocalPrice',
                                message: 'open',
                            },
                            "*"
                        )
                          //window.location.href = `${getBaseUrl()}/${currentLang}/${currentLang === 'en' ? 'shopping/get-local-price/': 'magasiner/obtenez-un-prix-local/'}?model=${getVehicle('model')}|${getVehicle('packageCode')}`
                        }
                        // Store selected dealer data in localstorage.
                        setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                      }}
                      data-menu-name="Reserve Your Mazda"
                      data-form-name="Find a dealer"
                      data-form-event="Visit Reserve Your Mazda"
                      /> 
                      }
                  </Fragment>
                ) : displayServiceHoursOnly ? (
                  <>
                  <Button
                      label={isSelected ? 'Selected' : languageController.getCopy('findDealer', 'bookServiceCta')}
                      className={isSelected ? 'mz-btn--primary' : 'mz-btn--red'}
                      onClick={()=>{
                        setIsModalOpen(true)
                        setDealerData(dealerData)
                        document.querySelector('.mz-react-forms-root').style.zIndex=150;
                        document.querySelector('body').classList.add('disabled');
                      }}
                      data-menu-name="Select dealer"
                      data-form-name="Find a dealer"
                      data-form-event="Book Service Modal"
                    />
                  </>
                )
                :(
                    <Button
                      label={isSelected ? 'Selected' : languageController.getCopy('global', 'selectDealer')}
                      className={isSelected ? 'mz-btn--primary' : 'mz-btn--red'}
                      buttonIcon={<Svg type="chevron_small" size={0.75} colour="white" style={{ top: '1px' }} />}
                      buttonIconPosition="right"
                      onClick={(e)=>{
                        window.postMessage(
                          {
                              type: "formEvent",
                              origin: 'preOrder',
                              message: dealerData,
                          },
                          "*"
                        )
                        onSelect(e)
                      }}
                      data-menu-name="Select dealer test"
                      data-form-name="Find a dealer"
                      data-form-event="Select a dealer"
                    />
                  )
              ) : (
                  <Fragment>
                    <Button
                      label={isSelected ? 'Selected' : languageController.getCopy('findDealer', 'bookServiceCta')}
                      className={isSelected ? 'mz-btn--primary' : 'mz-btn--red'}
                      onClick={()=>{
                        setIsModalOpen(true)
                        setDealerData(dealerData)
                        document.querySelector('.mz-react-forms-root').style.zIndex=150;
                        document.querySelector('body').classList.add('disabled');
                      }}
                      data-menu-name="Select dealer"
                      data-form-name="Find a dealer"
                      data-form-event="Book Service Modal"
                    />
                    <Link
                      text={languageController.getCopy('findDealer', 'bookTestDriveCta')}
                      className="mz-btn mz-btn--red"
                      href={BaTDLink}
                      onClick={() => {
                        // Store selected dealer data in localstorage.
                        setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                      }}
                      data-menu-name="Book a Test Drive"
                      data-form-name="Find a dealer"
                      data-form-event="Visit Book a Test Drive"
                    />
                    <Link
                      text={languageController.getCopy('findDealer', 'GetQuoteCta')}
                      className="mz-btn mz-btn--secondary"
                      href={GaQLink}
                      onClick={() => {
                        // Store selected dealer data in localstorage.
                        setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                      }}
                      data-menu-name="Get a Quote"
                      data-form-name="Find a dealer"
                      data-form-event="Visit Get a Quote"
                    />
                  </Fragment>
                )
            }
          </div>
        </Collapse>
        
      </div>
    </>
  )
}

DealerCard.propTypes = {
  dealerData: PropTypes.object.isRequired,
  distance: PropTypes.number,
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isLean: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  userCurrentPos: PropTypes.object,
  isSelected: PropTypes.bool,
  BaSALink: PropTypes.string,
  BaTDLink: PropTypes.string,
  GaQLink: PropTypes.string,
  language: PropTypes.string,
  isEmbeddedOnBnP: PropTypes.bool,
  currentLang: PropTypes.string,
}

DealerCard.defaultTypes = {
  isActive: false,
  isLean: false,
  isSelected: false,
  isEmbeddedOnBnP: false,
  language: 'en'
}

export default DealerCard